export class AccountsService {
    constructor(httpService, accountsFactory, userFactory) {
        this.httpService = httpService;
        this.accountsFactory = accountsFactory;
        this.userFactory = userFactory;
    }
    async getAccounts() {
        const response = await this.httpService.get('accounts');
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener las cuentas.');
        }
        const content = await response.json();
        return content.map((data) => this.createAccount(data));
    }
    async getAccount(accountId) {
        const response = await this.httpService.get(`account/${accountId}`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener la cuenta.');
        }
        return this.createAccount(await response.json());
    }
    async saveAccount(account) {
        const response = await this.httpService.post('account', account);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al guardar la cuenta.');
        }
    }
    async getAccountUsers(accountId) {
        const response = await this.httpService.get(`account/${accountId}/users`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener los usuarios de la cuenta.');
        }
        const content = await response.json();
        return content.map((dto) => this.userFactory.createUser(dto.id, dto.accountId, dto.creationDate, dto.lastLoginDate, dto.lastActivityDate, dto.enabled, dto.typeId, dto.name, dto.email));
    }
    // private createAccount({ id, enabled, name, allowedGames }: any): Account {
    //     return this.accountsFactory.createAccount(id, enabled, name, allowedGames);
    // }
    createAccount({ id, enabled, name, games_allowed }) {
        return this.accountsFactory.createAccount(id, enabled, name, games_allowed);
    }
}
